// import React from "react";
// import { motion } from "framer-motion";
// import { ChevronDown } from "lucide-react";

// const sections = [
//   {
//     title: "Innovative Designs",
//     text: `We create modern, innovative website designs that not only look visually stunning but also enhance user engagement. Our web solutions are crafted to reflect your brand identity while providing seamless navigation and experience for your audience.`,
//     img: "/web1.png",
//   },
//   {
//     title: "Responsive Websites",
//     text: `Our responsive websites ensure perfect display on all devices — desktops, tablets, and smartphones. By focusing on usability and mobile-first design, we provide a smooth, intuitive, and accessible browsing experience for every visitor.`,
//     img: "/web2.png",
//     reverse: true,
//   },
//   {
//     title: "Dynamic Functionality",
//     text: `From interactive UI elements to dynamic content and real-time updates, we develop websites that are both functional and engaging. We implement modern technologies to make your website adaptable and future-proof for your users.`,
//     img: "/web3.png",
//   },
//   {
//     title: "Custom Web Solutions",
//     text: `We provide fully customized web solutions tailored to your business goals. Our team ensures easy management, scalability, and optimization so your website grows along with your brand, making it unique, efficient, and productive.`,
//     img: "/web4.png",
//     reverse: true,
//   },
// ];


// const ScrollSection = ({ children }) => (
//   <motion.div
//     initial={{ opacity: 0, y: 60 }}
//     whileInView={{ opacity: 1, y: 0 }}
//     transition={{ duration: 0.7, ease: "easeOut" }}
//     viewport={{ once: false, amount: 0.3 }}
//   >
//     {children}
//   </motion.div>
// );

// export default function WebDevelopmentTailwind() {
//   const handleScroll = () => {
//     document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
//   };

//   return (
//   <div className="font-poppins text-gray-100 overflow-x-hidden scroll-smooth relative bg-black">

//     {/* Premium Gold Glow Background */}
//     <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0a0a0a] to-black">
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(212,175,55,0.15),_transparent_65%)]"></div>
//       <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(212,175,55,0.18),_transparent_75%)]"></div>
//     </div>

//     {/* Hero Section */}
//     <ScrollSection>
//       <section className="relative h-screen flex flex-col items-center justify-center text-center overflow-hidden">

//         <motion.h1
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           className="text-[64px] font-extrabold uppercase tracking-wider mb-5
//           bg-clip-text text-transparent 
//           bg-gradient-to-r from-[#C5A46D] via-[#E7C787] to-[#C5A46D]
//           drop-shadow-[0_4px_10px_rgba(212,175,55,0.5)]"
//         >
//           Web Development
//         </motion.h1>

//         <motion.p
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//           className="text-[20px] max-w-2xl text-gray-300 leading-relaxed"
//         >
//           Why are we the best Web Development Company in Indore?
//         </motion.p>

//         <motion.div
//           className="absolute bottom-20 cursor-pointer animate-bounce text-[#E7C787]"
//           onClick={handleScroll}
//           whileHover={{ scale: 1.2 }}
//         >
//           <ChevronDown size={42} />
//         </motion.div>
//       </section>
//     </ScrollSection>

//     {/* Sections */}
//     <div
//       id="web-sections"
//       className="max-w-6xl mx-auto py-24 px-6 md:px-10 space-y-24 relative z-10"
//     >
//       {sections.map(({ title, text, img, reverse }, idx) => (
//         <ScrollSection key={idx}>
//           <div
//             className={`flex flex-col md:flex-row items-center gap-12 ${
//               reverse ? "md:flex-row-reverse" : ""
//             }`}
//           >
//             {/* Text Box */}
//             <motion.div
//               className="flex-1 bg-black/60 border border-[#D4AF37]/30 backdrop-blur-xl 
//               p-10 md:p-12 rounded-[20px] 
//               shadow-[0_10px_25px_rgba(212,175,55,0.15)]
//               hover:shadow-[0_14px_35px_rgba(212,175,55,0.25)]
//               transition-all duration-300"
//               whileHover={{ y: -5 }}
//             >
//               <h2
//                 className="text-[38px] md:text-[38px] font-bold mb-4 relative
//                 bg-clip-text text-transparent
//                 bg-gradient-to-r from-[#E5C07B] to-[#F6E7C1]
//                 after:block after:w-20 after:h-1 after:bg-[#D4AF37] after:rounded mt-2"
//               >
//                 {title}
//               </h2>

//               <p className="text-[17px] md:text-[17px] leading-relaxed text-gray-300">
//                 {text}
//               </p>
//             </motion.div>

//             {/* Image */}
//             <motion.div
//               className="flex-1 text-center"
//               whileHover={{ scale: 1.05 }}
//               transition={{ duration: 0.4 }}
//             >
//               <img
//                 src={img}
//                 alt={title}
//                 className="w-full max-w-md md:max-w-lg rounded-[20px]
//                 shadow-[0_12px_30px_rgba(212,175,55,0.25)]"
//               />
//             </motion.div>
//           </div>
//         </ScrollSection>
//       ))}
//     </div>

//     {/* Bounce Animation Fix */}
//     <style>{`
//       @keyframes bounce {
//         0%,100% { transform: translateY(0); }
//         50% { transform: translateY(10px); }
//       }
//       .animate-bounce {
//         animation: bounce 1.8s infinite;
//       }
//     `}</style>
//   </div>
// );

// }





import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const sections = [
  {
    title: "Innovative Designs",
    text: `We create modern, innovative website designs that enhance user engagement while reflecting your brand identity. Seamless navigation and aesthetics are at the core of our solutions.`,
    img: "/web1.png",
  },
  {
    title: "Responsive Websites",
    text: `Our responsive websites look perfect on all devices — desktops, tablets, and smartphones. We prioritize mobile-first design and accessibility for a smooth browsing experience.`,
    img: "/web2.png",
    reverse: true,
  },
  {
    title: "Dynamic Functionality",
    text: `From interactive UI elements to real-time features, we build websites that are powerful, dynamic, and future-ready with modern technologies.`,
    img: "/web3.png",
  },
  {
    title: "Custom Web Solutions",
    text: `We provide fully customized and scalable web solutions. Our goal: a visually unique, efficient, and productive website tailored to your brand.`,
    img: "/web4.png",
    reverse: true,
  },
];

const ScrollSection = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    viewport={{ once: false, amount: 0.3 }}
  >
    {children}
  </motion.div>
);

export default function WebDevelopmentTailwind() {
  const handleScroll = () => {
    document.getElementById("web-sections").scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-poppins text-gray-100 overflow-x-hidden scroll-smooth relative bg-black">

      {/* Premium Gold Glow */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-black via-[#0a0a0a] to-black">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(212,175,55,0.15),_transparent_65%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(212,175,55,0.18),_transparent_75%)]"></div>
      </div>

      {/* Hero Section */}
      <ScrollSection>
        <section className="relative min-h-[80vh] sm:h-screen flex flex-col items-center justify-center text-center px-4 sm:px-6 overflow-hidden">

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-[34px] sm:text-[48px] md:text-[64px] font-extrabold uppercase tracking-wide mb-5
            bg-clip-text text-transparent bg-gradient-to-r from-[#C5A46D] via-[#E7C787] to-[#C5A46D]"
          >
            Web Development
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-[15px] sm:text-[18px] md:text-[20px] max-w-xl sm:max-w-2xl text-gray-300 leading-relaxed"
          >
            Why are we the best Web Development Company in Indore?
          </motion.p>

          <motion.div
            className="absolute bottom-10 sm:bottom-20 cursor-pointer animate-bounce text-[#E7C787]"
            onClick={handleScroll}
            whileHover={{ scale: 1.2 }}
          >
            <ChevronDown size={36} />
          </motion.div>

        </section>
      </ScrollSection>

      {/* Content Sections */}
      <div
        id="web-sections"
        className="max-w-7xl mx-auto py-16 sm:py-24 px-4 sm:px-6 md:px-10 space-y-20"
      >
        {sections.map(({ title, text, img, reverse }, idx) => (
          <ScrollSection key={idx}>
            <div
              className={`flex flex-col md:flex-row items-center gap-10 sm:gap-12 ${
                reverse ? "md:flex-row-reverse" : ""
              }`}
            >
              {/* Text */}
              <motion.div
                className="flex-1 bg-black/60 border border-[#D4AF37]/30 backdrop-blur-xl 
                p-6 sm:p-8 md:p-10 rounded-[20px]
                shadow-[0_10px_25px_rgba(212,175,55,0.15)]
                hover:shadow-[0_14px_35px_rgba(212,175,55,0.25)]
                transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <h2
                  className="text-[26px] sm:text-[32px] md:text-[38px] font-bold mb-4
                  bg-clip-text text-transparent bg-gradient-to-r from-[#E5C07B] to-[#F6E7C1]"
                >
                  {title}
                </h2>

                <div className="w-16 h-1 bg-[#D4AF37] rounded mb-4"></div>

                <p className="text-[15px] sm:text-[17px] leading-relaxed text-gray-300">
                  {text}
                </p>
              </motion.div>

              {/* Image */}
              <motion.div
                className="flex-1 text-center"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.4 }}
              >
                <img
                  src={img}
                  alt={title}
                  className="w-full max-w-sm sm:max-w-md md:max-w-lg rounded-[20px]
                  shadow-[0_12px_30px_rgba(212,175,55,0.25)]"
                />
              </motion.div>
            </div>
          </ScrollSection>
        ))}
      </div>

      {/* Bounce Animation */}
      <style>{`
        @keyframes bounce {
          0%,100% { transform: translateY(0); }
          50% { transform: translateY(10px); }
        }
        .animate-bounce {
          animation: bounce 1.8s infinite;
        }
      `}</style>
    </div>
  );
}
